import { permissionsByEntity, useCheckAccountType, useCheckPermissions } from '@cmg/auth';
import React from 'react';

import { useGetOfferingEntitlementsQuery } from '../check-entitlements/useGetOfferingEntitlementsQuery';

type Props = {
  offeringId: string;
};

type AccessCheckResult = {
  loading: boolean;
  canRead: boolean;
  canUpdate: boolean;
  isSellSideAccount: boolean;
};

/**
 * Checks accessibility of an Retail Indication.
 */
export function useCheckRetailIndicationAccess({ offeringId }: Props): AccessCheckResult {
  const hasRead = useCheckPermissions([permissionsByEntity.RetailDemand.READ]);
  const hasFull = useCheckPermissions([permissionsByEntity.RetailDemand.FULL]);

  const { data: entitlements, loading } = useGetOfferingEntitlementsQuery({ offeringId });
  const isSellSideAccount = useCheckAccountType('SELL_SIDE');
  const accessChecks = React.useMemo(
    () => ({
      canRead: hasRead && isSellSideAccount && entitlements.includes('READ:RETAIL_INDICATION'),
      canUpdate: hasFull && isSellSideAccount && entitlements.includes('UPDATE:RETAIL_INDICATION'),
    }),
    [hasRead, hasFull, entitlements, isSellSideAccount]
  );

  return { loading, ...accessChecks, isSellSideAccount };
}

export default useCheckRetailIndicationAccess;
